module.exports = __webpack_public_path__ + "static/media/SFX_SwishIn_1_soft.54c4da7c.mp3";